import { render, staticRenderFns } from "./processing-rules.vue?vue&type=template&id=3a2ab5aa"
import script from "./processing-rules.vue?vue&type=script&lang=js"
export * from "./processing-rules.vue?vue&type=script&lang=js"
import style0 from "./processing-rules.vue?vue&type=style&index=0&id=3a2ab5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports